import { useEffect, useRef } from "preact/hooks";
import type { Strings } from "../state.js";
import type { TranscriptMessage } from "../types.js";

export interface TranscriptProps {
  messages: readonly TranscriptMessage[];
  strings: Strings;
}

export function Transcript({ messages, strings }: TranscriptProps) {
  const logRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const log = logRef.current;
    if (log) log.scrollTop = log.scrollHeight;
  }, [messages]);

  return (
    <div
      ref={logRef}
      class="va-transcript"
      role="log"
      aria-live="polite"
      aria-label={strings.transcriptLabel}
    >
      {messages.map((message, index) => (
        <div
          class={`va-transcript-message va-transcript-message-${message.role}`}
          data-final={String(message.final)}
          key={`${message.role}-${index}`}
        >
          <span class="va-sr-only">
            {message.role === "user" ? strings.userLabel : strings.agentLabel}:{" "}
          </span>
          <span dir="auto">{message.text}</span>
        </div>
      ))}
    </div>
  );
}
